import { WEB_VERSION } from '~/consts';

export default async function ({ redirect, app, store }) {
  let { data } = await app.$axios.get(WEB_VERSION);

  if (!helpers.isEmpty(data) && data.applicationSystem.code == 9) {
    store.commit('setState', { key: 'maintenance_message', value: data.applicationSystem.message })

    return redirect('/maintenance');
  }
}